import { render, staticRenderFns } from "./recentOrders.vue?vue&type=template&id=18c5971c&"
import script from "./recentOrders.vue?vue&type=script&lang=js&"
export * from "./recentOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports